module.exports = __webpack_public_path__ + "static/media/mediaReachLogo.199bda3b.png";